<script>
  import TitleSubtitle from '../TitleSubtitle';

  export let title;
</script>

<div class='center'>
  <TitleSubtitle>
    <svelte:fragment slot='title'>No {title} Found</svelte:fragment>
    <svelte:fragment slot='subtitle'>Try modifying your search query or filters.</svelte:fragment>
  </TitleSubtitle>
</div>

<style>
  .center {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
</style>
